<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>Manage leaves</h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard </router-link>\ Leaves
                </div>
              </div>
              <div class="breadcrumb-right">
                <v-btn @click="__add()" class="mt-4 btn btn-primary mr-1" dark>
                  <i class="fa fa-plus"></i>
                  Add leave
                </v-btn>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div
              class="wizard wizard-2"
              data-wizard-clickable="true"
              data-wizard-state="step-first"
              id="kt_wizard_v2"
            >
              <div class="wizard-body py-8 px-8 py-lg-10 px-lg-10">
                <!--begin: Wizard Form-->

                <v-row v-if="loading">
                  <v-col cols="6">
                    <v-skeleton-loader
                      type="article, list-item-three-line,article"
                      v-bind="attrs"
                    ></v-skeleton-loader>
                  </v-col>
                  <v-col cols="6">
                    <v-skeleton-loader
                      type="date-picker"
                      v-bind="attrs"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row v-if="!loading && leave_requests.length > 0">
                  <v-col cols="6">
                    <table
                      class="table mt-3"
                      v-if="!loading && leave_requests.length"
                    >
                      <tr
                        :key="leave_category.id"
                        v-for="(leave_category, index) of leave_requests"
                      >
                        <td class="px-3">
                          <a
                            @click="__edit(leave_category)"
                            class="font-weight-black mr-2"
                            href="#"
                          >
                            {{ leave_category.title }}</a
                          >&nbsp;

                          <i
                            :class="
                              leave_category.is_active
                                ? 'dot-active'
                                : 'dot-inactive'
                            "
                            class="fas fa-circle"
                          ></i>
                          <br />
                          <small>
                            <span class="font-weight-medium">{{
                              leave_category.leave_start_date
                                | moment("Do MMMM YYYY")
                            }}</span>
                          </small>
                          <small v-if="leave_category.leave_end_date">
                            -
                            <span class="font-weight-medium">{{
                              leave_category.leave_end_date
                                | moment("Do MMMM YYYY")
                            }}</span>
                          </small>
                        </td>
                        <td class="px-3">
                          <span v-if="leave_category.category">
                            <span
                              class="badge badge-primary ml-2 text-capitalize"
                            >
                              {{ leave_category.category }}
                            </span>
                          </span>
                        </td>
                        <td class="px-3">
                          <span
                            class="badge"
                            v-bind:class="{
                              'badge-danger':
                                leave_category.status == 'canceled',
                              'badge-success':
                                leave_category.status == 'approved',
                              'badge-danger':
                                leave_category.status == 'declined',
                              'badge-warning':
                                leave_category.status == 'pending',
                            }"
                          >
                            {{ leave_category.status_text }}
                          </span>
                        </td>

                        <td class="px-3 pr-0 text-center">
                          <a
                            @click="__cancel(leave_category.id)"
                            class="mr-2"
                            href="#"
                            v-if="leave_category.status == 'pending'"
                          >
                            <span>
                              <i
                                title="Cancel leave"
                                class="far fa-window-close text-danger"
                              ></i>
                            </span>
                          </a>
                          <a
                            @click="__viewDetail(leave_category)"
                            class="navi-link"
                            href="#"
                            v-if="leave_category.status != 'pending'"
                          >
                            <span class="navi-icon">
                              <i class="far fa-eye"></i>
                            </span>
                          </a>
                        </td>
                        <!--                                        <td>-->
                        <!--                                            <b-dropdown-->
                        <!--                                                    size="sm"-->
                        <!--                                                    variant="link"-->
                        <!--                                                    toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"-->
                        <!--                                                    no-caret-->
                        <!--                                                    right-->
                        <!--                                                    no-flip-->
                        <!--                                            >-->
                        <!--                                                <template v-slot:button-content>-->
                        <!--                                                    <slot>-->
                        <!--                                                        <span>-->
                        <!--                                                                    <i class="flaticon-more-1"></i>-->
                        <!--                                                                  </span></slot>-->
                        <!--                                                </template>-->
                        <!--                                                &lt;!&ndash;begin::Navigation&ndash;&gt;-->
                        <!--                                                <div class="navi navi-hover ">-->

                        <!--                                                    &lt;!&ndash;                                                  <b-dropdown-text tag="div" class="navi-item">&ndash;&gt;-->
                        <!--                                                    &lt;!&ndash;                                                    <a href="#" class="navi-link" @click="detail(leave_category.id)">&ndash;&gt;-->
                        <!--                                                    &lt;!&ndash;                                                            <span class="navi-icon">&ndash;&gt;-->
                        <!--                                                    &lt;!&ndash;                                                              <i class="fas fa-eye"></i>&ndash;&gt;-->
                        <!--                                                    &lt;!&ndash;                                                            </span>&ndash;&gt;-->
                        <!--                                                    &lt;!&ndash;                                                      <span class="navi-text"> View </span>&ndash;&gt;-->
                        <!--                                                    &lt;!&ndash;                                                    </a>&ndash;&gt;-->
                        <!--                                                    &lt;!&ndash;                                                  </b-dropdown-text>&ndash;&gt;-->
                        <!--                                                    <b-dropdown-text tag="div" class="navi-item">-->
                        <!--                                                        <a href="#" class="navi-link" @click="__edit(leave_category.id)">-->
                        <!--                                                            <span class="navi-icon">-->
                        <!--                                                              <i class="flaticon-edit"></i>-->
                        <!--                                                            </span>-->
                        <!--                                                            <span class="navi-text"> Edit </span>-->
                        <!--                                                        </a>-->
                        <!--                                                    </b-dropdown-text>-->

                        <!--                                                    <b-dropdown-text tag="div" class="navi-item">-->
                        <!--                                                        <a href="#" class="navi-link"-->
                        <!--                                                           @click="__delete(leave_category.id)">-->
                        <!--                                                            <span class="navi-icon">-->
                        <!--                                                              <i class="fas fa-trash"></i>-->
                        <!--                                                            </span>-->
                        <!--                                                            <span class="navi-text">  Delete</span>-->
                        <!--                                                        </a>-->
                        <!--                                                    </b-dropdown-text>-->

                        <!--                                                </div>-->
                        <!--                                                &lt;!&ndash;end::Navigation&ndash;&gt;-->
                        <!--                                            </b-dropdown>-->

                        <!--                                        </td>-->
                      </tr>
                    </table>
                  </v-col>
                  <v-col cols="6">
                    <leaveCalender
                      :leave_requests="leave_requests"
                    ></leaveCalender>
                  </v-col>
                </v-row>
                <div
                  class="row mt-3"
                  v-if="!loading && leave_requests.length < 1"
                >
                  <div class="col-md-12 text-center">
                    <div class="p-20">
                      <img src="@/assets/media/images/no-data-found.png" />
                      <h5 class="align-center mt-10">
                        No leave requests available at the moment
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12" v-if="total > perPage">
                    <b-pagination
                      :per-page="perPage"
                      :total-rows="total"
                      @input="__get"
                      first-number
                      last-number
                      v-model="page"
                    ></b-pagination>
                    <!--  -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <create-and-update
            @refresh_leave_request="__get"
            ref="leave_category"
          ></create-and-update>
          <v-dialog max-width="800px" v-model="detail_dialog">
            <v-card v-if="leave_detail">
              <v-toolbar dark>
                <v-card-title class="headline">
                  Leave request status
                  <hr />
                </v-card-title>

                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="detail_dialog = false">
                    <i class="fas fa-times"></i>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <v-card-text style="height: 500px">
                <v-container>
                  <div class="">
                    <span
                      class="badge badge-warning p-2"
                      v-if="leave_detail.status == 'pending'"
                      >{{ leave_detail.status }}</span
                    >
                    <span
                      class="badge badge-success p-2"
                      v-if="leave_detail.status == 'approved'"
                      >{{ leave_detail.status }}</span
                    >
                  </div>
                  <div class="text-secondary h6">
                    <span class="font-weight-bold">Title : </span>
                    <span class="font-weight-medium">
                      {{ leave_detail.title }}
                    </span>
                  </div>
                  <div class="text-secondary h6">
                    <span class="font-weight-bold">Full name : </span>
                    <span class="font-weight-medium">
                      {{ leave_detail.user_full_name }} </span
                    ><span v-if="leave_detail.user_type"
                      >({{ leave_detail.user_type }})</span
                    >
                  </div>

                  <div class="mt-5 mb-5">
                    <div class="text-secondary h6">
                      <span class="font-weight-bold">Start date : </span> :
                      <span class="font-weight-medium">{{
                        leave_detail.leave_start_date | moment("Do MMMM YYYY")
                      }}</span>
                    </div>
                    <div class="text-secondary h6">
                      <span class="font-weight-bold">End date : </span> :
                      <span class="font-weight-medium">{{
                        leave_detail.leave_end_date | moment("Do MMMM YYYY")
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="text-secondary h6 mt-2"
                    v-if="leave_detail.status"
                  >
                    <span class="font-weight-bold">Status : </span>
                    <span
                      class="badge badge-warning p-2"
                      v-if="leave_detail.status == 'pending'"
                      >{{ leave_detail.status }}</span
                    >
                    <span
                      class="badge badge-success p-2"
                      v-if="leave_detail.status == 'approved'"
                      >{{ leave_detail.status_text }}</span
                    >
                    <span
                      class="badge badge-danger p-2"
                      v-if="leave_detail.status == 'declined'"
                      >{{ leave_detail.status_text }}</span
                    >
                    <span
                      class="badge badge-danger p-2"
                      v-if="leave_detail.status == 'canceled'"
                      >{{ leave_detail.status_text }}</span
                    >
                  </div>
                  <hr />
                  <div class="text-secondary">
                    <p class="h6 font-weight-bold">Description</p>
                    <p
                      class="font-weight-regular subtitle-1"
                      v-html="leave_detail.description"
                    ></p>
                  </div>

                  <v-row
                    class="mt-5"
                    v-if="
                      leave_detail.attachment_1 ||
                      leave_detail.attachment_2 ||
                      leave_detail.attachment_3
                    "
                  >
                    <v-col cols="12"> Attachments </v-col>
                    <v-col cols="12">
                      <v-list-item-group color="primary">
                        <v-list-item v-if="leave_detail.attachment_1">
                          <v-list-item-icon>
                            <v-icon> mdi-file</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <a
                                :href="leave_detail.attachment_one_path"
                                target="_blank"
                                >Attachment - {{ leave_detail.attachment_1 }}</a
                              >
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="leave_detail.attachment_2">
                          <v-list-item-icon>
                            <v-icon> mdi-file</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <a
                                :href="leave_detail.attachment_two_path"
                                target="_blank"
                                >Attachment - {{ leave_detail.attachment_2 }}</a
                              >
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="leave_detail.attachment_2">
                          <v-list-item-icon>
                            <v-icon> mdi-file</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              <a
                                :href="leave_detail.attachment_three_path"
                                target="_blank"
                                >Attachment - {{ leave_detail.attachment_2 }}</a
                              >
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-col>
                  </v-row>
                  <div
                    class="text-secondary"
                    v-if="leave_detail.processed_comment"
                  >
                    <p class="h6 font-weight-bold">Approved/Declined remarks</p>
                    <p
                      class="font-weight-medium subtitle-1"
                      v-html="leave_detail.processed_comment"
                    ></p>
                  </div>
                  <div
                    class="text-secondary"
                    v-if="leave_detail.processed_date"
                  >
                    <p class="h6 font-weight-bold">Approved/Declined date</p>
                    <p
                      class="font-weight-medium subtitle-1"
                      v-html="leave_detail.processed_date"
                    ></p>
                  </div>
                  <div
                    class="text-secondary"
                    v-if="leave_detail.processed_user"
                  >
                    <p class="h6 font-weight-bold">Approved/Declined By</p>
                    <p
                      class="font-weight-medium subtitle-1"
                      v-html="leave_detail.processed_user"
                    ></p>
                  </div>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="mr-2 cancel-btn"
                  text
                  x-large
                  @click="detail_dialog = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
import CreateAndUpdate from "./CreateAndUpdate";
import leaveCalender from "./leaveCalender";
import LeaveRequestService from "@/core/services/leave/leave-request/LeaveRequestService";
import { SiteSettingMixin } from "@/mixins/SiteSettingMixin";

const leaveRequestService = new LeaveRequestService();
export default {
  mixins: [SiteSettingMixin],
  name: "leave-category",
  display: "Table",
  order: 8,
  components: {
    CreateAndUpdate,
    leaveCalender,
  },
  data() {
    return {
      active_statuses: [
        { title: "Active", value: "active" },
        { title: "In Active", value: "in_active" },
      ],
      leave_requests: [],
      page: null,
      loading: false,
      perPage: null,
      total: null,
      search: {
        active: "active",
        is_parent: "null",
      },
      detail_dialog: false,
      leave_detail: null,
    };
  },
  mounted() {
    if (this.checkTeacherMenuAccess("leave_request") == false) {
      this.$router.push({ name: "404" });
    } else {
      this.__get();
    }
  },
  computed: {},
  methods: {
    getApplicable_users(users) {
      return users.split(",");
    },
    __get() {
      this.loading = true;
      leaveRequestService
        .paginate(this.search)
        .then((response) => {
          this.leave_requests = response.data.data;
          this.page = response.data.meta.current_page;
          this.total = response.data.meta.total;
          this.perPage = response.data.meta.per_page;
        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    leavestatus(status) {
      if (status) {
        switch (status) {
          case "pending":
            return "badge-warning";
            break;
          case "approved":
            return "badge-success";
            break;
          case "decline":
            return "badge-danger";
            break;
          case "canceled":
            return "badge-danger";
            break;
        }
      } else {
        return "badge-warning";
      }
    },
    __add() {
      this.$refs["leave_category"].showModal();
    },
    __edit(leave_category) {
      if (leave_category.status != "pending") {
        this.$snotify.error("You Cannot Edit this Leave Request ");
      } else this.$refs["leave_category"].showModal(leave_category.id);
    },

    __cancel(id) {
      this.$confirm({
        message: `Are you sure? Want to Cancel`,
        button: {
          no: "No",
          yes: "Yes",
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: (confirm) => {
          if (confirm) {
            leaveRequestService
              .cancell(id)
              .then((response) => {
                this.$snotify.success("Sucessfully Deleted");
                this.__get();
              })
              .catch((error) => {
                //console.log(error);
              });
          }
        },
      });
    },
    __delete(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: (confirm) => {
          if (confirm) {
            leaveRequestService
              .delete(id)
              .then((response) => {
                this.$snotify.success("Sucessfully Deleted");
                this.__get();
              })
              .catch((error) => {
                //console.log(error);
              });
          }
        },
      });
    },
    __viewDetail(leave) {
      this.detail_dialog = true;
      this.leave_detail = leave;
    },
  },
};
</script>
<style scoped>
</style>
